'use strict';

const {
  millisRemaining,
  timeRemaining,
} = require('../../groupon-deal-timer/helpers');

const {
  JUICE_PROGRAM_ID,
  DESKTOP_FF_NAME,
  TIMER_ADJUST_MINUTES,
} = require('./constants');

function setAdjustedJuiceTime(deal, platform, featureFlags) {
  if (!isJuiceProgramEnabled({ platform, featureFlags })) {
    return;
  }

  if (isJuicePricingOption(deal.displayOption)) {
    let endAt;
    if (
      (endAt =
        deal.displayOption &&
        deal.displayOption.pricingMetadata &&
        deal.displayOption.pricingMetadata.offerEndsAt)
    ) {
      const endAtDate = new Date(endAt);
      deal.displayOption.pricingMetadata.offerEndsAt = new Date(
        endAtDate - TIMER_ADJUST_MINUTES * 60 * 1000
      ).toISOString();
    }
  }

  if (isInJuiceGracePeriod(deal.displayOption)) {
    deal.displayOption.price = deal.displayOption.regularPrice;
    deal.displayOption.discountPercent = Math.round(
      ((deal.displayOption.value.amount -
        deal.displayOption.regularPrice.amount) /
        deal.displayOption.value.amount) *
        100
    );
  }
}

function isInJuiceGracePeriod(dealOption) {
  if (
    !dealOption ||
    !dealOption.pricingMetadata ||
    dealOption.pricingMetadata.programId !== JUICE_PROGRAM_ID
  ) {
    return null;
  }
  const { offerBeginsAt, offerEndsAt } = dealOption.pricingMetadata;
  if (!offerBeginsAt || !offerEndsAt) {
    return null;
  }
  let endDate;
  const now = new Date();
  if (offerEndsAt) {
    endDate = new Date(offerEndsAt);
  }
  return endDate <= now;
}

function isJuicePricingOption(dealOption) {
  if (
    !dealOption ||
    !dealOption.pricingMetadata ||
    dealOption.pricingMetadata.programId !== JUICE_PROGRAM_ID
  ) {
    return null;
  }
  const { offerBeginsAt, offerEndsAt } = dealOption.pricingMetadata;
  if (!offerBeginsAt || !offerEndsAt) {
    return null;
  }

  let endDate;
  let startDate;
  const now = new Date();
  if (offerBeginsAt) {
    startDate = new Date(offerBeginsAt);
  }
  if (offerEndsAt) {
    endDate = new Date(offerEndsAt);
  }
  return startDate <= now && now <= endDate;
}

function isJuiceProgramEnabled({ featureFlags, platform }) {
  if (!platform || !featureFlags) {
    return null;
  }
  const { isTouch } = platform;
  return !isTouch && featureFlags.enabled(DESKTOP_FF_NAME);
}

function progressComplete(startDate, endDate) {
  if (!startDate || !endDate) {
    return null;
  }
  const fullTime = endDate - startDate;
  if (!(fullTime > 0)) {
    return null;
  }
  const msLeft = millisRemaining(endDate);
  return Number(((fullTime - msLeft) / fullTime).toFixed(2));
}

function clockTimeLeft(endDate) {
  if (!endDate) {
    return null;
  }
  const msLeft = millisRemaining(endDate);
  if (!(msLeft > 0)) {
    return null;
  }
  const remainedTime = timeRemaining(msLeft);
  if (!remainedTime) {
    return null;
  }
  return formatJuiceTimer(remainedTime);
}

function textTimeLeft(endDate) {
  if (!endDate) {
    return null;
  }
  const msLeft = millisRemaining(endDate);
  if (!(msLeft > 0)) {
    return null;
  }
  const remainedTime = timeRemaining(msLeft);
  if (!remainedTime) {
    return null;
  }
  return formatTextTimer(remainedTime);
}

function formatJuiceTimer(remainedTime) {
  const { minutes } = remainedTime;
  let { seconds } = remainedTime;
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${minutes}:${seconds}`;
}

function formatTextTimer(remainedTime) {
  const { minutes, seconds } = remainedTime;
  return `${minutes}m ${seconds}s`;
}

module.exports = {
  textTimeLeft,
  clockTimeLeft,
  formatJuiceTimer,
  formatTextTimer,
  isInJuiceGracePeriod,
  isJuicePricingOption,
  isJuiceProgramEnabled,
  progressComplete,
  setAdjustedJuiceTime,
};
